import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const emojiApi = createApi({
  reducerPath: 'emojiApi',
  baseQuery: rtkBaseQuery('/staff/Reaction'),
  tagTypes: ['Reactions'],

  endpoints: (builder) => ({
    createEmoji: builder.mutation({
      query: (body) => ({
        url: '/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Reactions'],
    }),

    updateEmoji: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Update?Id=${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Reactions'],
    }),

    getAllEmojis: builder.query({
      query: () => '/GetAll',
      providesTags: ['Reactions'],
    }),

    getEmojiById: builder.query({
      query: ({ id }) => ({
        url: `/GetById/${id}`,
      }),
    }),

    deleteEmoji: builder.mutation({
      query: ({ id }) => ({
        url: `/Delete?id=${id}`,
        method: 'Delete',
      }),
      invalidatesTags: ['Reactions'],
    }),
  }),
});

export const {
  useCreateEmojiMutation,
  useUpdateEmojiMutation,
  useGetAllEmojisQuery,
  useGetEmojiByIdQuery,
  useDeleteEmojiMutation,
} = emojiApi;
